import { IWorkOrderService } from "../common/data/dtos/work-order-service";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/WorkOrderService';

interface WorkOrderServiceResponse {
    success: boolean;
    workOrderService?: IWorkOrderService;
    workOrderServices?: IWorkOrderService[];
    error?: string;
}

type CreateWorkOrderServiceType = Omit<IWorkOrderService, 'id'> | Partial<IWorkOrderService>;

const createWorkOrderService = async (workOrderService: CreateWorkOrderServiceType): Promise<WorkOrderServiceResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkOrderService>(`${BASE_PATH}`, workOrderService);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteWorkOrderService= async (id: string): Promise<WorkOrderServiceResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IWorkOrderService>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getByWorkOrder = async (workOrderId: string): Promise<WorkOrderServiceResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkOrderService>(`${BASE_PATH}/GetByWorkOrder?workOrderId=${workOrderId}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workOrderServices: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createWorkOrderService,
    deleteWorkOrderService,
    getByWorkOrder
};